import type { GuideConfig } from "@/types"

export const endingDialogues: GuideConfig["prologueDialogues"] = [
    {
        speaker: "map.speaker.doctor",
        expression: "normal",
        side: "left",
        text: "map.guide.epilogue.0",
    },
    {
        speaker: "map.speaker.amiya",
        expression: "normal",
        side: "right",
        text: "map.guide.epilogue.1",
    },
    {
        speaker: "map.speaker.doctor",
        expression: "normal",
        side: "left",
        text: "map.guide.epilogue.2",
    },
    {
        speaker: "map.speaker.doctor",
        expression: "normal",
        side: "left",
        text: "map.guide.epilogue.3",
    },
    {
        speaker: "map.speaker.amiya",
        expression: "happy",
        side: "right",
        text: "map.guide.epilogue.4",
    },
    {
        speaker: "map.speaker.amiya",
        expression: "happy",
        side: "right",
        text: "map.guide.epilogue.5",
    },
]

export const guideConfig: GuideConfig = {
    prologueDialogues: [
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.0",
        },
        {
            speaker: "map.speaker.amiya",
            expression: "smile",
            side: "right",
            text: "map.guide.prologue.1",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.2",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.3",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.4",
        },
        {
            speaker: "map.speaker.amiya",
            expression: "normal",
            side: "right",
            text: "map.guide.prologue.5",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.6",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.7",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.8",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.9",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.10",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.11",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.12",
        },
        {
            speaker: "map.speaker.savage",
            expression: "happy",
            side: "left",
            text: "map.guide.prologue.13",
        },
        {
            speaker: "map.speaker.amiya",
            expression: "thinking",
            side: "right",
            text: "map.guide.prologue.14",
        },
        {
            speaker: "map.speaker.savage",
            expression: "smile",
            side: "left",
            text: "map.guide.prologue.15",
        },
        {
            speaker: "map.speaker.savage",
            expression: "smile",
            side: "left",
            text: "map.guide.prologue.16",
        },
        {
            speaker: "map.speaker.savage",
            expression: "happy",
            side: "left",
            text: "map.guide.prologue.17",
        },
        {
            speaker: "map.speaker.amiya",
            expression: "happy",
            side: "right",
            text: "map.guide.prologue.18",
        },
        {
            speaker: "map.speaker.doctor",
            expression: "normal",
            side: "left",
            text: "map.guide.prologue.20",
        },
        {
            speaker: "map.speaker.amiya",
            expression: "normal",
            side: "right",
            text: "map.guide.prologue.21",
        },
    ],
    steps: [
        {
            id: 0,
            dialogues: [
                {
                    speaker: "map.speaker.savage",
                    expression: "smile",
                    side: "left",
                    text: "map.guide.step0.0",
                },
            ],
            dialoguePosition: "corner",
            highlightTargets: [
                {
                    selector: "[data-node-id='ri-start']",
                    padding: 30,
                },
                {
                    selector: "[data-node-id='ri-end']",
                    padding: 10,
                },
            ],
            requireTargetClick: false,
        },
        {
            id: 1,
            dialogues: [
                {
                    speaker: "map.speaker.savage",
                    expression: "smile",
                    side: "left",
                    text: "map.guide.step1.0",
                },
                {
                    speaker: "map.speaker.amiya",
                    expression: "happy",
                    side: "left",
                    text: "map.guide.step1.1",
                },
            ],
            dialoguePosition: "corner",
            highlightTargets: [
                {
                    selector: "[data-node-id='ri-evt1']",
                    padding: 10,
                },
                {
                    selector: "[data-node-id='ri-evt3']",
                    padding: 0,
                },
            ],
            onEnter: {
                moveToNode: "ri-m3",
            },
            requireTargetClick: false,
        },
        {
            id: 2,
            dialogues: [
                {
                    speaker: "map.speaker.savage",
                    expression: "happy",
                    side: "left",
                    text: "map.guide.step2.0",
                },
                {
                    speaker: "map.speaker.amiya",
                    expression: "happy",
                    side: "left",
                    text: "map.guide.step2.1",
                },
            ],
            dialoguePosition: "corner",
            highlightTargets: [
                {
                    selector: "[data-node-id='ri-m3']",
                    padding: -10,
                },
                {
                    selector: "[data-node-id='ri-evt4']",
                    padding: 0,
                },
            ],
            disabledTargets: ["[data-node-id='ri-m3']"],
            requireTargetClick: false,
            onEnter: {
                moveToNode: "ri-evt1",
            },
            onComplete: {
                switchRegion: "sargon",
                withTransition: true,
            },
        },
    ],
    epilogueDialogues: endingDialogues,
}
